import { Icon } from '@/components/shared/element/icons';
import { Text } from '@/components/shared/element/text';
import { Flex } from '@/components/shared/layout/flex';

export const DealerResultNotFound: React.FC = () => (
  <Flex
    direction="column"
    alignItems="center"
    justifyContent="center"
    rowGap="2"
    css={{
      width: '100%',
      height: '100%',
      textAlign: 'center',
      py: '$space-9',
      '@lg': {
        py: '$space-16',
      },
    }}
  >
    <Icon icon="face-sad" size="lg" color="icon-gray-light" />
    <Text as="p" variant="text-gray">
      ไม่พบรายชื่อ กรุณาค้นหาใหม่
    </Text>
  </Flex>
);
DealerResultNotFound.displayName = 'SectionDealerResultNotFound';
